import React, { useState, useEffect } from 'react';
import { Link, useHistory, useLocation, Redirect } from "react-router-dom";
import './navbar.css';
import { useLastLocation } from 'react-router-last-location';
import { useSelector, useDispatch } from 'react-redux';
import { logout, authSelector, clearState } from '../Auth/authSlice';
import { setLink, commonSelector } from '../../redux/commonReduxSlice';
import { Layout, Menu, Breadcrumb, Button, Row, Col, List, Avatar, Spin, notification, Badge, Space } from 'antd';
import { BsFillBellFill } from 'react-icons/bs';
import { useGoogleLogout } from 'react-google-login'
import { LoadingOutlined, SyncOutlined, UnorderedListOutlined,FileAddOutlined, EyeTwoTone, FileTextOutlined, WechatOutlined, CommentOutlined } from '@ant-design/icons';
 
// import Icon from '@ant-design/icons';

import toast, { Toaster, ToastBar } from 'react-hot-toast';
import { HomeOutlined, UserOutlined } from "@ant-design/icons";
import socketIOClient from "socket.io-client";
import ability from '../../config/ability';
import EditPassword from '../EditPassword/index'
import ViewNotification from '../ViewNotification/index'
import ModifySignature from '../ModifySignature';
import axios from '../../redux/axios';
import {
  initiateSocket, disconnectSocket,
  subscribeToChat, sendMessage
} from './Socket';
const { Item, SubMenu } = Menu;
const { Header, Content, Footer, Sider } = Layout;
const MenuItemGroup = Menu.ItemGroup;
const antIcon = <SyncOutlined style={{ fontSize: 24 }} spin />;

const rightStyle = { position: 'absolute', top: 0, right: 0 };
const notirightStyle = { position: 'absolute', top: 0, right: 55 };

export default function Navbar(props) {
  const location = useLocation()
  const history = useHistory()
  const lastLocation = useLastLocation();
  const dispatch = useDispatch();
  const [isLoading, setLoading] = React.useState(false);
  // notification.destroy();
  const { user } = useSelector(
    authSelector
  );
  // console.log('user')
  // console.log(user)
  // console.log(user.profilePic)
  const { defaultPath, currentPath, previousPath } = useSelector(
    commonSelector
  );
  




  const currentPathLink = currentPath ? currentPath : location.pathname;

  // useEffect(() => {
   
  //   setTimeout(() => {

  //     // dispatch(getCollaborationNotification());
      
  //   }, 1000);
   

  // }, []);


  // let items = [
  //   // { key: '1', label: 'Dashboard', path: '/dashboard' },
  //   // { key: '2', label: 'All Process', path: '/all-process' },
  //   // { key: '3', label: 'Departments', path: '/departments' },
  //   // { key: '4', label: 'User Roles', path: '/user-roles' },
  //   // { key: '5', label: 'Manage Users', path: '/manage-users' },
  //   // { key: '6', label: 'Sub Admin', path: '/sub-admin' }
  // ];



  let items = [{
    key: '1', label: 'Dashboard', path: '/dashboard', iconValue: <img
      src={"./newicons/grid.svg"}
      alt="grid"
      style={{ width: "18px" }}
    />
  }];

  if (user.userType == 'admin') {
    items = [
      {
        key: '1', label: 'Dashboard', path: '/dashboard', iconValue: <img
          src={"./newicons/grid.svg"}
          alt="grid"
          style={{ width: "18px" }}
        />
      },
      {
        key: '2', label: 'All Seen Stamp', path: '/all-seen-stamp', iconValue: <img
          src={"./newicons/sliders.svg"}
          alt="sliders"
          style={{ width: "18px" }}
        />
      },
      {
        key: '3', label: 'Departments', path: '/departments', iconValue: <img
          src={"./newicons/server.svg"}
          alt="server"
          style={{ width: "18px" }}
        />
      },
      {
        key: '4', label: 'Appointments', path: '/appointments', iconValue: <img
          src={"./newicons/clipboard.svg"}
          alt="clipboard"
          style={{ width: "18px" }}
        />
      },
      // { key: '4', label: 'User Roles', path: '/user-roles' },
      {
        key: '5', label: 'Manage Users', path: '/manage-users', iconValue: <img
          src={"./newicons/user.svg"}
          alt="user"
          style={{ width: "18px" }} />
      },
      {
        key: '6', label: 'Sub Admin', path: '/sub-admin', iconValue: <img
          src={"./newicons/trello.svg"}
          alt="trello"
          style={{ width: "18px" }} />
      },
      { key: '7', label: 'Manage Activity', path: '/manage-activity', iconValue: <UnorderedListOutlined /> }
    ];
  }

  if (user.userType == 'subAdmin') {
    // items.push({ key: '1', label: 'Dashboard', path: '/dashboard' });
    if (ability.can('allProcessTab', 'viewOnGoingProcess')) {
      items.push({
        key: '2', label: 'All Seen Stamp', path: '/all-seen-stamp', iconValue: <img
          src={"./newicons/sliders.svg"}
          alt="sliders"
          style={{ width: "18px" }}
        />
      });
    }

    if (ability.can('manageB', 'view') || ability.can('manageIo', 'view') || ability.can('manageId', 'view')) {
      items.push({
        key: '3', label: 'Departments', path: '/departments', iconValue: <img
          src={"./newicons/server.svg"}
          alt="server"
          style={{ width: "18px" }}
        />
      });
    }

    if (ability.can('userRolesTab', 'viewOnlyRoles')) {
      // items.push({ key: '4', label: 'User Roles', path: '/user-roles' });
      items.push({
        key: '4', label: 'Appointments', path: '/appointments', iconValue: <img
          src={"./newicons/clipboard.svg"}
          alt="clipboard"
          style={{ width: "18px" }}
        />
      });
    }

    if (ability.can('manageUsersTab', 'viewOnlyUsers')) {
      items.push({
        key: '5', label: 'Manage Users', path: '/manage-users', iconValue: <img
          src={"./newicons/user.svg"}
          alt="user"
          style={{ width: "18px" }} />
      });
    }

    items.push({ key: '7', label: 'Manage Activity', path: '/manage-activity', iconValue: <UnorderedListOutlined /> });

  }

  if (user.userType == 'Clerk') {
    //  items.push({ key: '1', label: 'Dashboard', path: '/dashboard' });
    items.push({
      key: '2', label: 'All Process', path: '/all-process', iconValue: <img
        src={"./newicons/sliders.svg"}
        alt="sliders"
        style={{ width: "18px" }}
      />
    });
    items.push({ key: '5', label: 'Keep in View', path: '/kiv-process', iconValue: <FileAddOutlined /> });
    // items.push({
    //   key: '3', label: 'All Users', path: '/view-all-users', iconValue: <img
    //     src={"./newicons/user.svg"}
    //     alt="user"
    //     style={{ width: "18px" }} />
    // });
    items.push({ key: '4', label: 'Collaborations', path: '/draft-document', iconValue: <FileTextOutlined /> });
  
  }

  if (user.userType == "DD's & AD's") {
    //  items.push({ key: '1', label: 'Dashboard', path: '/dashboard' });
    items.push({
      key: '2', label: 'All Process', path: '/all-process', iconValue: <img
        src={"./newicons/sliders.svg"}
        alt="sliders"
        style={{ width: "18px" }}
      />
    });

    items.push({ key: '5', label: 'Keep in View', path: '/kiv-process', iconValue: <FileAddOutlined /> });
    // items.push({
    //   key: '3', label: 'All Users', path: '/view-all-users', iconValue: <img
    //     src={"./newicons/user.svg"}
    //     alt="user"
    //     style={{ width: "18px" }} />
    // });
    items.push({ key: '4', label: 'Collaborations', path: '/draft-document', iconValue: <FileTextOutlined /> });
  }

  if (user.userType == 'CHD') {
    //  items.push({ key: '1', label: 'Dashboard', path: '/dashboard' });
    items.push({
      key: '2', label: 'All Process', path: '/all-process', iconValue: <img
        src={"./newicons/sliders.svg"}
        alt="sliders"
        style={{ width: "18px" }}
      />
    });

    items.push({ key: '5', label: 'Keep in View', path: '/kiv-process', iconValue: <FileAddOutlined /> });
    // items.push({
    //   key: '3', label: 'All Users', path: '/view-all-users', iconValue: <img
    //     src={"./newicons/user.svg"}
    //     alt="user"
    //     style={{ width: "18px" }} />
    // });
    items.push({ key: '4', label: 'Collaborations', path: '/draft-document', iconValue: <FileTextOutlined /> });
  }

  // const [selectedKey, setSelectedKey] = useState(items.find(_item => location.pathname.startsWith(_item.path)).key)
  // const skey = items.find(_item => location.pathname.startsWith(_item.path))?items.find(_item => location.pathname.startsWith(_item.path)).key:lastLocation?items.find(_item => lastLocation.pathname.startsWith(_item.path)).key:defaultPath;
  const skey = items.find(_item => currentPathLink.startsWith(_item.path)) ? items.find(_item => currentPathLink.startsWith(_item.path)).key : previousPath ? items.find(_item => previousPath.startsWith(_item.path)).key : defaultPath;
  const [selectedKey, setSelectedKey] = useState(skey)



  const onClickMenu = (item) => {
    const clicked = items.find(_item => _item.key === item.key)
    localStorage.removeItem("deptTypeName");
    //console.log(clicked)
    if (clicked) {
      const prelocation = lastLocation ? lastLocation.pathname : null;
      dispatch(setLink(location.pathname, clicked.path));
      // console.log('clicked.path')
      // console.log(clicked.path)
      history.push(clicked.path);
    }
  }


  useEffect(() => {
    window.scrollTo(0, 0);
    // const socket = socketIOClient('http://localhost:3000');
    // var endpoint = process.env.REACT_APP_API_URL;
    //console.log('endpoint',endpoint)
    // var socket = socketIOClient('http://localhost:3000', { transports: ['websocket'] });
    var socket = socketIOClient(process.env.REACT_APP_SOCKET_URL, { transports: ['websocket'] });
    //socket.on("outgoing data", data => alert(JSON.stringify(data)));
    socket.on('notification_to_' + user.username, function (data) { openNotification(data) });

    return () => {
      socket.disconnect();
    }
  }, []);

  useEffect(() => {
    if (items.find(_item => location.pathname.startsWith(_item.path))) {
      setSelectedKey(items.find(_item => location.pathname.startsWith(_item.path)).key)
    }
    // setSelectedKey(items.find(_item => location.pathname.startsWith(_item.path)).key)
  }, [location])

  const openNotification = (msg) => {
    let notificationArray = [msg];
    notification.open({
      message: msg.title[0].toUpperCase() + msg.title.slice(1),
      //description:msg.data.message,
      description: <>
        <List
          className="noti-dropdown-item1"
          // style={{borderBottom:'none',borderTop:'solid 1px #e4e4e4',padding:'padding: 10px 0px !important;'}}
          style={{ borderBottom: 'none' }}
          itemLayout="horizontal"
          dataSource={notificationArray}
          renderItem={item => (
            <List.Item>
              <List.Item.Meta
                avatar={<Avatar src={item.imagePath + item.data.userDetail.profilePic} />}
                title={<span className="name">{item.data.userDetail.username}</span>}
                description={<span className="notice-text" style={{ maxWidth: '100%', whiteSpace: 'normal' }}>{item.data.message}</span>}
              />
            </List.Item>
          )}
        />
      </>,
      duration: 0,
      onClick: () => {
        // console.log('Notification Clicked!');
      },
    });
  };

  function logOut() {
 
    setLoading(true);
    let logoutAll = dispatch(logout()).then((res) => {
      setLoading(false);
      history.push("/login");
      notification.destroy();
    });

    //
  }

  const clickNotif = () => {
    let msg = {
      "data": {
        "sender_username": "clerkuser03",
        "message": "You have to sign Cadet recruitment Process new template 01 process.",
        "isTrigger": false,
        "uuid": "536a56a0-1895-406d-9e1b-86f43869fcd6",
        "userDetail": {
          "profilePic": "1634631495154.jpeg",
          "fullName": "Clerk user 03"
        }
      },
      "imagePath": "http://localhost:3000/profilePic/",
      "title": "new doc assigned"
    };
    openNotification(msg);
  }
  const [drive, setDrive] = React.useState(null);
  const sendDataToParent = (index) => {
    // console.log(index);
    setDrive(index);
  };

  // console.log('current path '+currentPathLink)
  // console.log('previous path '+previousPath)
  let userName = user.username.trim();
  return (
    <>
      <Spin indicator={antIcon} style={{ textAlign: 'center', width: '100%' }} spinning={isLoading} />
      <Toaster
        toastOptions={{
          className: '',
          style: {
            border: '1px solid #713200',
            padding: '16px',
            color: '#713200',
            marginTop: 50
          },
        }}
      >
        {(t) => (
          <ToastBar toast={t}>
            {({ icon, message }) => (
              <>
                {icon}
                {message}
                {t.type !== 'loading' && (
                  <button onClick={() => toast.dismiss(t.id)}>X</button>
                )}
              </>
            )}
          </ToastBar>
        )}
      </Toaster>
      <Header className='appHeader' style={{ padding: 0 }}>
        {/* <div className="logo" /> */}
        <Menu className="new-nav-bg" triggerSubMenuAction={'click'} theme="light" mode="horizontal" selectedKeys={[selectedKey]} onClick={onClickMenu} defaultSelectedKeys={['1']}>

          {items.map((item) => (
            <Menu.Item style={{ float: 'left' }} icon={item.iconValue} key={item.key}>{item.label} </Menu.Item>
          ))}


          {user.userType == 'Clerk' || user.userType == "DD's & AD's" || user.userType == 'CHD' ?
            <>
            
              {/* <Menu.Item style={notirightStyle} icon={<BsFillBellFill className="gly-rotate-45" style={{ color: '#000', fontSize: 20, marginLeft: 12, marginBottom: -6 }} />}></Menu.Item> */}
             

              {/* <SubMenu className="noti-dropdown-box" style={notirightStyle} title={<Badge size="small" style={{marginRight: 44}} count={5}><span><WechatOutlined  style={{ color: '#003360', fontSize: 25, marginLeft: 12, marginRight: 44, marginBottom: -6 }} /></span></Badge>}> */}
                {/* <NotifyDropdown /> */}
                {/* <ViewNotification sendDataToParent={sendDataToParent} /> */}
              {/* </SubMenu> */}

              <SubMenu className="noti-dropdown-box" style={notirightStyle} title={<Badge size="small" count={drive}><span><BsFillBellFill className="gly-rotate-45" style={{ color: '#003360', fontSize: 20, marginLeft: 12, marginRight: 6, marginBottom: -6, transform: 'rotate(20deg)' }} /></span></Badge>}>
                {/* <NotifyDropdown /> */}
                <ViewNotification sendDataToParent={sendDataToParent} />
              </SubMenu>
              {/* <SubMenu style={rightStyle} title={<span><Avatar src="./images/user-01.jpeg" /></span>}> */}
              <SubMenu style={rightStyle} title={<span>{user.profilePic && user.profilePic.length > 0 ? <Avatar src={user.profilePic} /> : <Avatar style={{ color: '#f56a00', backgroundColor: '#fde3cf' }} >{userName.charAt(0).toUpperCase()} </Avatar>}</span>}>
                <Menu.Item style={{ margin: '10px 0px 0px 0px' }}>
                  <EditPassword />
                  {/* <Button type="link" style={{ color: "#000", fontWeight: 500 }} >Edit Password</Button> */}
                </Menu.Item>
                <Menu.Item style={{ margin: '0px' }}>
                  {/* <Button type="link" style={{ color: "#000", fontWeight: 500 }} >Modify Signature</Button> */}
                  <ModifySignature />
                </Menu.Item>
                <Menu.Item style={{ margin: '0px 0px 10px 0px' }}>
                  <Button type="link" onClick={logOut} style={{ color: "#000", fontWeight: 500 }} >Log Out</Button>
                </Menu.Item>
                {/* <Button type="primary" size="small" onClick={() => clickNotif()}>
      Confirm
    </Button> */}
              </SubMenu>
            </>
            :
            <>
              {/* <SubMenu style={rightStyle} title={<span><Avatar src="./images/user-01.jpeg" /></span>}> */}
              <SubMenu style={rightStyle} title={<span>{user.profilePic && user.profilePic.length > 0 ? <Avatar src={user.profilePic} /> : <Avatar style={{ color: '#f56a00', backgroundColor: '#fde3cf' }} >{userName.charAt(0).toUpperCase()} </Avatar>}</span>}>
                <Menu.Item > <Button type="link" onClick={logOut} style={{ color: "#000", fontWeight: 500 }} >Log Out</Button></Menu.Item>
              </SubMenu>

            </>
          }

        </Menu>
      </Header>
    </>
  );
}
